import React, { useState, useEffect } from 'react';
import './ContactoPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const ContactoPage = () => {
  const [formSent, setFormSent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSent(true);
  };

  return (
    <div className="contacto-page">
      <Header />
      <AnimatedBackground particleCount={12} staticCount={4} />

      <main className="contacto-main">
        <div className="contacto-hero-card">
          {/* Columna izquierda: esencia + pilares */}
          <div className="contacto-content">
            <span className="contacto-tag">CONTACTO</span>
            <h1 className="contacto-headline">Conecta con Javiland</h1>
            <p className="contacto-narrative">
              Un ecosistema desde Colombia: bienestar, viajes, artesanías y comunidad.
              Yoga, ecoturismo comunitario, joyería colombiana y espacios con propósito.
            </p>
            <div className="contacto-pillars">
              <span className="contacto-pillar"><i className="fas fa-map-marker-alt"></i> Colombia</span>
              <span className="contacto-pillar"><i className="fas fa-users"></i> Comunidad</span>
              <span className="contacto-pillar"><i className="fas fa-spa"></i> Bienestar</span>
              <span className="contacto-pillar"><i className="fas fa-gem"></i> Artesanías</span>
            </div>
            <div className="contacto-social">
              <a href="https://www.instagram.com/javilandoficial/" target="_blank" rel="noopener noreferrer" className="contacto-instagram">
                <i className="fab fa-instagram"></i>
                @javilandoficial
              </a>
            </div>
          </div>

          {/* Columna derecha: formulario */}
          <div className="contacto-form-wrap">
            <h2 className="contacto-form-title">Escríbenos</h2>
            {formSent ? (
              <div className="contacto-form-success">
                <i className="fas fa-check-circle"></i>
                <p>Gracias por tu mensaje. Te responderemos pronto.</p>
              </div>
            ) : (
              <form className="contacto-form" onSubmit={handleSubmit}>
                <div className="contacto-form-group">
                  <input type="text" placeholder="Nombre" required />
                </div>
                <div className="contacto-form-group">
                  <input type="email" placeholder="Email" required />
                </div>
                <div className="contacto-form-group">
                  <select>
                    <option value="general">Consulta general</option>
                    <option value="bienestar">Bienestar / Yoga</option>
                    <option value="viajes">Viajes / Conoce Colombia</option>
                    <option value="voluntariado">Voluntariado Colombia</option>
                    <option value="conecta-tu-camino">Psicología / Coaching</option>
                    <option value="tienda">Tienda</option>
                  </select>
                </div>
                <div className="contacto-form-group">
                  <textarea placeholder="Mensaje" rows="4" required></textarea>
                </div>
                <button type="submit" className="contacto-form-btn">Enviar</button>
              </form>
            )}
          </div>
        </div>
      </main>

    </div>
  );
};

export default ContactoPage;
